import { FC } from "react";
import { Handle, Position } from "react-flow-renderer";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import { useStore, connect } from "src/store/connect";

interface PhoneValidationBlockProps {
  data: NodeData;
}

const PhoneValidationBlock: FC<PhoneValidationBlockProps> = ({ data }) => {
  const classes = useStyles();
  const state = useStore();

  return (
    <div className={classes.root}>
      <Handle
        type="target"
        position={Position.Left}
        onConnect={(params) => console.log("handle onConnect", params)}
        isConnectable={data.connectable}
      />
      <div
        className={`${
          !data.highlighted && state.simulationRunning ? classes.opacity : ""
        }`}
      >
        <Typography className={classes.type}>Validación de Teléfono</Typography>
      </div>
      <Handle
        type="source"
        position={Position.Right}
        id="a"
        isConnectable={false}
      />
    </div>
  );
};

export default connect(PhoneValidationBlock);

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "259px",
    padding: "22px 10px 35px 26px",
    borderRadius: "8px",
    boxShadow: "0 2px 24px 0 rgba(0, 0, 0, 0.08)",
    border: "solid 1px #5E52F9",
    borderTopWidth: "12px",
    backgroundColor: "#fff",
    color: "#1D262C",
  },
  opacity: {
    opacity: 0.36,
  },
  label: {
    fontSize: "14px",
    fontWeight: 500,
    overflowWrap: "break-word",
  },
  labelVariable: {
    fontSize: "14px",
    fontWeight: 500,
    overflowWrap: "break-word",
    marginTop: "10px",
  },
  variable: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#FFBC00",
    overflowWrap: "break-word",
  },
  labelEmpty: {
    fontSize: "14px",
    fontWeight: 400,
    color: "#445561",
  },
  type: {
    margin: "67px 0 0 0",
    fontSize: "14px",
  },
}));
